import { executeHttpCall } from '@/services/httpClientHelper.js'
import { vehicleVariablesByEcuFamiliesAndVariableTypes, engineVariablesByEcuFamiliesAndVariableTypes , navistarVariablesByEcuFamiliesAndVariableTypes, vehicleGetVariableTypesByEcuFamilies, engineGetVariableTypesByEcuFamilies,navistarGetVariableTypesByEcuFamilies, getOperationalVariablesGUIElements, vehicleEcuFamily, engineEcuFamily,  navistarEcuFamily } from '@/services/importingJsons.js'

const operationalVariables = {
  namespaced: true,
  state: {
    ecuFamilies: {
      options: [],
      loading: false,
      error: false
    },
    variableTypes: {
      options: [],
      loading: false,
      error: false
    },
    variables: {
      options: [],
      loading: false,
      error: false
    },
    operationalVariablesElements: {
      objects: {},
      loading: false,
      error: false
    },
    jsonInBackend: {
      data: null
    },
    reportTypeSettingsFromFile: false,
    selected: {
      customReportLink: null,
      ecuFamilies: [],
      variableTypes: [],
      variables: [],
      dataInclusionPercentage: '0',
      lifetimeOption: true,
      sinceLatestFlashOption: null,
      deltaReadoutOption: null,
      typeOfValueType: null,
      valueTypesDiagram: null,
      dateAndMileage: {
        raw: {
          readoutDateFrom: '',
          readoutDateTo: '',
          dwSaveDateFrom: '',
          dwSaveDateTo: '',
          mileageReadoutFrom: null,
          mileageReadoutTo: null,
          includeVehiclesSinceStart: false,
          maximumLoss: null
        },
        formatted: {
          readoutDateFrom: '',
          readoutDateTo: '',
          dwSaveDateFrom: '',
          dwSaveDateTo: '',
          mileageReadoutFrom: null,
          mileageReadoutTo: null,
          includeVehiclesSinceStart: false,
          maximumLoss: null
        }
      },
      reportTypeSettings: {
        reportType: null,
        displayBoxPlots: false,
        displayPartIdentificationNumbers: false,
        readoutScopePerProduct: '',
        dataInclusionPercentage: '0',
        valueTypes: [],
        typeOfValueType: null
      }
    }
  },
  mutations: {
    ecuFamilies (state, payload) {
      state.ecuFamilies[payload.prop] = payload.value
    },
    variableTypes (state, payload) {
      state.variableTypes[payload.prop] = payload.value
    },
    variables (state, payload) {
      state.variables[payload.prop] = payload.value
    },
    operationalVariablesElements (state, payload) {
      state.operationalVariablesElements[payload.prop] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.prop] = payload.value
    },
    reportTypeSettingsFromFile (state, value) {
      state.reportTypeSettingsFromFile = value
    },
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    selectedReportTypeSettings (state, payload) {
      state.selected.reportTypeSettings[payload.prop] = payload.value
    },
    setDefaultState (state) {
      state.ecuFamilies = {
        options: [],
        loading: false,
        error: false
      }
      state.variableTypes = {
        options: [],
        loading: false,
        error: false
      }
      state.variables = {
        options: [],
        loading: false,
        error: false
      }
      state.operationalVariablesElements = {
        objects: {},
        loading: false,
        error: false
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null,
        ecuFamilies: [],
        variableTypes: [],
        variables: [],
        dataInclusionPercentage: '0',
        lifetimeOption: true,
        sinceLatestFlashOption: null,
        deltaReadoutOption: null,
        typeOfValueType: null,
        valueTypesDiagram: null,
        dateAndMileage: {
          raw: {
            readoutDateFrom: '',
            readoutDateTo: '',
            dwSaveDateFrom: '',
            dwSaveDateTo: '',
            mileageReadoutFrom: null,
            mileageReadoutTo: null,
            includeVehiclesSinceStart: false,
            maximumLoss: null
          },
          formatted: {
            readoutDateFrom: '',
            readoutDateTo: '',
            dwSaveDateFrom: '',
            dwSaveDateTo: '',
            mileageReadoutFrom: null,
            mileageReadoutTo: null,
            includeVehiclesSinceStart: false,
            maximumLoss: null
          }
        },
        reportTypeSettings: {
          reportType: null,
          displayBoxPlots: false,
          displayPartIdentificationNumbers: false,
          readoutScopePerProduct: '',
          dataInclusionPercentage: '0',
          valueTypes: [],
          typeOfValueType: null
        }
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit, dispatch }, data) {
      commit('overwriteSelected', data)
      commit('reportTypeSettingsFromFile', true)
      dispatch('loadVariableTypesData')
      dispatch('loadVariableData')
    },
    updateSelection ({ commit }, payload) {
      if (payload.propName) payload.prop = payload.propName // TODO: Harmonize payload interfaces
      commit('selected', payload)
    },
    loadEcuFamiliesData ({ commit, rootGetters, dispatch }) {
      dispatch('loadOperationalVariablesElementsObjects')
      const productType = rootGetters['population/getProductType']
      if (!productType) return

      commit('ecuFamilies', { prop: 'loading', value: true })
      commit('ecuFamilies', { prop: 'error', value: false })

      const featureFunction = (productType) =>{
        if(productType === 'VEHICLE')return  vehicleEcuFamily()
        if(productType === 'ENGINES')return  engineEcuFamily()
        if(productType?.Id === 'EC_NAVISTAR')return navistarEcuFamily()

      }
      featureFunction(productType).then(result => {
          const options = result.map(x => ({
                id: x.EcuFamily,
                label: x.EcuFamily
              }))
          commit('ecuFamilies', { prop: 'options', value: options })
          dispatch('loadOperationalVariablesElementsObjects')
    
      }).catch(e => {
      console.log('Error loading ecu families:' + e)
      commit('ecuFamilies', { prop: 'error', value: true })
      }).finally(() => {
          commit('ecuFamilies', { prop: 'loading', value: false })
        })
    },
    loadOperationalVariablesElementsObjects ({ commit }) {
      commit('operationalVariablesElements', { prop: 'loading', value: true })
      commit('operationalVariablesElements', { prop: 'error', value: false })
      getOperationalVariablesGUIElements().then(response => {
        commit('operationalVariablesElements', { prop: 'objects', value: response })
      }).catch(error => {
        console.error('OperationalVariables:getOperationalVariablesElements: ', error)
        commit('operationalVariablesElements', { prop: 'error', value: true })
      }).finally(() => {
        commit('operationalVariablesElements', { prop: 'loading', value: false })
        commit('reportTypeSettingsFromFile', false) // Report type settings state loaded and rendered
      })
    },
    loadVariableTypesData ({ state, rootGetters, commit }) {
      const productType = rootGetters['population/getProductType']
      commit('variableTypes', { prop: 'loading', value: true })
      commit('variableTypes', { prop: 'error', value: false })
      const ecuList = state.selected.ecuFamilies

      const featureFunction = (productType) =>{
        if(productType === 'VEHICLE')return  vehicleGetVariableTypesByEcuFamilies()
        if(productType === 'ENGINES')return  engineGetVariableTypesByEcuFamilies()
        if(productType?.Id === 'EC_NAVISTAR')return navistarGetVariableTypesByEcuFamilies()

      }
        featureFunction(productType).then(response => {

          //Appending variables types based on ecu list 
          var variableTypeBasedOnEcuSelection = []
          ecuList.forEach((ecu) => 
          variableTypeBasedOnEcuSelection.push(...response.filter(object => object[ecu])[0][ecu])
          )
          //Removing duplicates
          const ids = variableTypeBasedOnEcuSelection.map(({ variableType }) => variableType)
          const responseFiltered = variableTypeBasedOnEcuSelection.filter(({ variableType }, index) =>
              !ids.includes(variableType, index + 1))
          
          const variableTypeList = responseFiltered.map(x => ({
            id: x.variableType,
            label: x.variableType
          }))
          commit('variableTypes', { prop: 'options', value: variableTypeList })
        }).catch(error => {
          console.error('OperationalVariables:getVariableTypeList: ', error)
          commit('variableTypes', { prop: 'error', value: true })
        }).finally(() => {
          commit('variableTypes', { prop: 'loading', value: false })
        })
    },
    loadVariableData ({ commit, rootGetters, state }) {
      const productType = rootGetters['population/getProductType']
      commit('variables', { prop: 'loading', value: true })
      commit('variables', { prop: 'error', value: false })
      const ecuList = state.selected.ecuFamilies
      const variableTypeList = state.selected.variableTypes

      const featureFunction = (productType) =>{
        if(productType === 'VEHICLE')return  vehicleVariablesByEcuFamiliesAndVariableTypes()
        if(productType === 'ENGINES')return  engineVariablesByEcuFamiliesAndVariableTypes()
        if(productType?.Id === 'EC_NAVISTAR')return navistarVariablesByEcuFamiliesAndVariableTypes()

      }
       
      featureFunction(productType).then(response => {
      //Appending variables types based on ecu list 
       var variableTypeBasedOnEcuSelection = []
       ecuList.forEach((ecu) => 
       variableTypeBasedOnEcuSelection.push(...response.filter(object => object[ecu])[0][ecu])
       )
      var variableTypeBasedOnVariableSelection = []
       variableTypeList.forEach((variable) => 
       variableTypeBasedOnVariableSelection.push(...variableTypeBasedOnEcuSelection.filter(o =>Object.keys(o).some(k => o[k].toLowerCase().includes(variable.toLowerCase()))))
       )
      
        const tempData = {}
        variableTypeBasedOnVariableSelection?.forEach(x => {
          if (!tempData[x.OperationalVariableType]) {
            tempData[x.OperationalVariableType] = {
              id: x.OperationalVariableType,
              label: x.OperationalVariableType,
              children: []
            }
          }
          tempData[x.OperationalVariableType].children.push({
            id: x.UniqueNameIdentifier,
            label: x.UniqueNameIdentifier + ' - ' + x.ShortDescription
          })
          
          const ids = tempData[x.OperationalVariableType].children.map(o => o.id)
          tempData[x.OperationalVariableType].children = tempData[x.OperationalVariableType].children.filter(({id}, index) => !ids.includes(id, index + 1))
        })
        commit('variables', { prop: 'options', value: Object.values(tempData) })
      }).catch(error => {
        console.error('OperationalVariables:getVariableList: ', error)
        commit('variables', { prop: 'error', value: true })
      }).finally(() => {
        commit('variables', { prop: 'loading', value: false })
      })
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default operationalVariables
